export default {
  resumeTemplates: [],
  letterTemplates: [],
  filters: [],
};
